// extracted by mini-css-extract-plugin
export default {"link":"link_link__+Nznz","block":"link_block__1fnX1","highlight":"link_highlight__UlonR","underline":"link_underline__YYnC6"};